import { applyActivityFilter as applyActivityFilterDiagram } from '@process-advisor/process-miner/processMiner/processMiner';
import type { ApiMethodBase } from '@process-advisor/process-miner/api/types';
import { Event } from '@process-advisor/process-miner/api/events';
import { apiProvider } from '@process-advisor/process-miner/api/apiProvider';

export type Props = ApiMethodBase & {
    constraint_type?: any,
    duration_operator?: any, 
    relative_operator?: any, 
    occurence_operator?: any, 
    duration_actual_from?: any, 
    duration_actual_to?: any, 
    occurence_actual_from?: any, 
    occurence_actual_to?: any, 
    value?: any, 
    percentile?: any,
    mode?: any}

export async function  applyActivityFilter ({
    constraint_type,
    duration_operator, 
    relative_operator, 
    occurence_operator, 
    duration_actual_from, 
    duration_actual_to, 
    occurence_actual_from, 
    occurence_actual_to, 
    value, 
    percentile,
    mode,
    eventEmitter,
}: Props)  {
    applyActivityFilterDiagram({
        constraint_type: constraint_type,
        duration_operator: duration_operator, 
        relative_operator: relative_operator, 
        occurence_operator: occurence_operator, 
        duration_actual_from: duration_actual_from, 
        duration_actual_to: duration_actual_to, 
        occurence_actual_from: occurence_actual_from, 
        occurence_actual_to: occurence_actual_to, 
        value: value, 
        percentile: percentile,
        mode: mode.mode
     });    
    eventEmitter.emit(Event.applyFilter);
    apiProvider.setDiagramVisualizer()   
    eventEmitter.emit(Event.updateGaugeMetrics);
};
